export class SkyConfirmationDialogButton {
  public text?: string;
  public autofocus?: boolean;
  public buttonType?: string;
}
